module.exports = __webpack_public_path__ + "img/product_stepink1.9af68bb5.png";